import axios from 'axios';
import { useState, useEffect } from 'react';
import { ThreeDots } from 'react-loader-spinner';
import Image from 'next/image';
import { ENDPOINTS } from '@/config/endpoints';
import dynamic from 'next/dynamic';
import { FormProvider } from '@/component/shared/contactForm/formContext';
import Head from 'next/head';
import { pushCleverTapEvent } from '@/component/shared/pushCleverTapEvent';

const ContactFormStep1 = dynamic(() => import('@/component/shared/contactForm/contactFormStep1'), {
  loading: () => <p>Loading...</p>})
const ContactFormStep2 = dynamic(() => import('@/component/shared/contactForm/contactFormStep2'), {
  loading: () => <p>Loading...</p>})

const Newsletter = ({post,paraUrl}) => {
  const [showNextStep, setShowNextStep]= useState(false)
  const pathName = process.env.URL+paraUrl;

  if (!post) {
    return <div className='fixed inset-0 z-[9999] items-center flex bg-[rgba(255,255,255,0.8)]'>
      <div className='w-[100px] mx-auto h-[100px] justify-center flex'>
        <ThreeDots
          height="80"
          width="80"
          radius="9"
          color="#032B5C"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName="m-auto"
          visible={true}
        />
      </div>
    </div>;
  }

  const dateFormat = (publishDate)=>{
    const dateString = new Date(publishDate);
    const options = { day:'numeric', year: 'numeric', month: 'short' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('en-US',options);
      return <span>{result}</span>
    }

  }
  

  const showSteps=()=>{
    setShowNextStep(true)
  }
  const showFirstStep=()=>{
    setShowNextStep(false)
  }

  const stripTags = (html) => {
    // Remove HTML tags using a regex
    const text = html.replace(/<\/?[^>]+(>|$)/g, "");
    return text;
  };

  const getFirstTwoLines = (htmlContent) => {
    const textContent = stripTags(htmlContent)
      .split("\n")
      .map(line => line.trim())
      .filter(line => line.length > 0);

    return textContent.slice(0, 2).join(" ");
  };
  useEffect(() => {
    pushCleverTapEvent("Finsights_Visited", {
      "PageName": 'Finsights',
    });
  }, []);

  return (
    <main className='mt-[100px]'>
      <Head>
        <title>{post.title}</title>
        <meta name="description" content={getFirstTwoLines(post.content)} />
        {/* OpenGraph tags */}
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={getFirstTwoLines(post.content)} />
        <meta property="og:image" content={post.featureImage} />
        <meta property="og:url" content={pathName} />
        <link rel="canonical" href={pathName} />
      </Head>
      {post !=null &&
        <section className='py-sp-big sm:pt-0'>
          <div className='container px-3 xm:px-2  lg:px-3'>
            <div className="flex flex-wrap">
              <div className="w-[60%] sm:pr-0 pr-4 md:w-full sm:w-full">
                <p className='text-sm text-[#7b7b7b] mb-1 sm:pt-10 md:pt-10'><span className='font-medium text-black'>Updated : </span>{dateFormat(post.modifiedAt || post.publishedDate)}</p>
                <h1 className='text-3xl sm:text-xl text-secondary fontWeight-medium pb-5' dangerouslySetInnerHTML={{ __html: post.title }}></h1>
                {post.featureImage && (
                <div className="w-full sm:h-auto overflow-hidden relative mb-5 sm:mb-xsp">
                  <Image src={post.featureImage} fetchPriority="high"quality={100} priority={true} alt={post.title} width={828} height={559} className="w-full h-auto object-cover rounded-md" />
                </div>             
                )}
                <div className='blog-content finsight-content' dangerouslySetInnerHTML={{ __html: post.content }}></div>
              </div>
              <div className="w-[38%] md:w-full sm:w-full md:mt-4 sm:mt-4">
                <div className='lg:sticky xm:sticky lg:top-[150px] xm:top-[120px]'>
                  <div className='mb-5'>
                    <FormProvider>
                      {!showNextStep ?
                        <ContactFormStep1 showStep1={showSteps} />:
                        <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew"  />
                      }
                    </FormProvider>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </section>
      }
    </main>
  );
};

export default Newsletter;


export async function getServerSideProps(context) {
  const paraUrl = context.resolvedUrl || null
  const paramSlug = paraUrl.replace(/^\/credlix-finsight\//, '');

  try {
    const response = await axios.get(ENDPOINTS.CREDLIX_FINSIGHTS_DETAIL(paramSlug));

    if (!response.data || !response.data.data || !response.data.data.content || response.data.data.content.length === 0) {
      console.error("Post not found or unexpected API response structure:", response.data);
      return {
        notFound: true,
      };
    }
    const postData = response.data.data;
    const post = {
      title: postData.title,
      slug: postData.slug,
      content: postData.content,
      featureImage: postData.featureImage,
      publishedDate: postData.publishedDate,
      modifiedAt: postData.modifiedAt,
      createdAt: postData.createdAt,
    };

    return {
      props: {
        post,
        paraUrl
      },
    };
  } catch (error) {
    console.error('Error fetching post:', error);
    return {
      notFound: true,
    };
  }
}
